import { useState, useEffect } from "react";
import { client } from "../prismic";
import { SliceZone } from "@prismicio/react";
import { components } from "../slices/components";

import '../scss/servicesPage.scss';
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";

export default function Servicios() {

  const [doc, setDoc] = useState(null);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const document = await client.getByUID('pages', 'services');
        setDoc(document);
      } catch (error) {
        console.warn("No se encontró el documento de Prismic para el HomePage aún.", error.message);
      }
    };
    fetchDoc();
  }, []);

  return (
    <>
      <LoadingScreen isLoading={!doc} />
      {doc && doc.data && (
        <main id="serviciosPrincipal">
          <SliceZone
            slices={doc.data.slices || doc.data.body || []}
            components={components}
          />
        </main>
      )}
    </>
  )
}